<script>
    import { onMount, onDestroy, afterUpdate } from "svelte";
    import { apiGetRefrnCode, apiWarehousing } from "../store/scanner.store";

    let barcodeInput_1;
    let barcodeInputValue_1 = "";
    let barcodeInput_2;
    let barcodeInputValue_2 = "";
    let scanTimeout;
    let interval;

    let item_code = ""; // 품목코드
    let item_nm = ""; // 품목명
    let steel_wt = ""; // 입고중량 / 무게
    let steel_mk = ""; // 제강사코드
    let mtrqlt = ""; // 강종명
    let mtrqlt_code = ""; // 강종 코드
    let steel_thick = ""; // 사이즈
    let steel_thickInput;

    onMount(() => {
        interval = setInterval(function () {
            if (barcodeInputValue_1 == "") {
                barcodeInput_1.focus();
            } else if (barcodeInputValue_2 == "") {
                barcodeInput_2.focus();
            } else if (steel_thick == "") {
                // steel_thickInput.focus();
            }
        }, 1000);
    });

    function inputBarcode(event) {
        clearTimeout(scanTimeout); // 입력 발생 시 타임아웃 초기화

        scanTimeout = setTimeout(function () {
            if (
                event.target.id === "barcode_1" ||
                barcodeInputValue_1.trim() === ""
            ) {
                if (barcodeInputValue_1.trim() !== "") {
                    item_code = barcodeInputValue_1.split(" ")[0];
                    steel_wt = barcodeInputValue_1.split(" ")[2];
                    steel_mk = barcodeInputValue_1.split(" ")[3];
                }
            } else {
                if (barcodeInputValue_2.trim() !== "") {
                    if (barcodeInputValue_2.includes("-")) {
                        mtrqlt = barcodeInputValue_2.trim().split("-")[1];
                    } else {
                        mtrqlt = barcodeInputValue_2.trim();
                    }

                    getRefrnCode();
                }
            }
        }, 900);
    }

    onDestroy(() => {
        clearTimeout(interval); // 페이지 이동 시 타임아웃 초기화
        clearTimeout(scanTimeout); // 페이지 이동 시 타임아웃 초기화
    });

    async function getRefrnCode() {
        try {
            mtrqlt_code = await apiGetRefrnCode(mtrqlt);

            item_nm =
                item_code +
                "/" +
                mtrqlt +
                "/" +
                steel_mk +
                "/" +
                steel_wt +
                "/" +
                steel_thick;
        } catch (e) {
            console.error("Error : ", e);
            alert(`Error! ${e}`);
        }
    }

    async function warehousing() {
        try {
            // item_code = "VDU849-022";
            // mtrqlt_code = "SK57";
            // mtrqlt = "SWRCH10A";
            // steel_thick = "6.5";
            // steel_wt = "2001";
            // steel_mk = "SF54086";

            // item_nm = item_code + "/" + mtrqlt + "/" + steel_mk + "/" + steel_wt + "/" + steel_thick;

            if (item_nm == "" || mtrqlt_code == "" || steel_thick == "") {
                alert("상위, 하위 바코드 스캔 후 사이즈까지 입력해주세요.");
                return;
            }

            if (
                await apiWarehousing(
                    item_code,
                    item_nm,
                    mtrqlt_code,
                    mtrqlt,
                    steel_thick,
                    steel_wt,
                    steel_mk
                )
            ) {
                item_code = "";
                mtrqlt_code = "";
                mtrqlt = "";
                steel_thick = "";
                steel_wt = "";
                steel_mk = "";
                barcodeInputValue_1 = "";
                barcodeInputValue_2 = "";
                alert("입고 완료되었습니다.");
            }
        } catch (e) {
            console.error("Error : ", e);
            alert("Error! 앱을 재시작 해주세요.");
        }
    }
</script>

<div class="scan-wrap">
    <div class="barcode-wrap">
        <div class="barcode-info">
            <p class="barcode-info-l">품목코드</p>
            <p class="barcode-info-r">{item_code}</p>
        </div>
        <div class="barcode-info">
            <p class="barcode-info-l">입고중량</p>
            <p class="barcode-info-r">{steel_wt}</p>
        </div>
        <div class="barcode-info">
            <p class="barcode-info-l">제강사코드</p>
            <p class="barcode-info-r">{steel_mk}</p>
        </div>
        <div class="barcode-info">
            <p class="barcode-info-l">강종</p>
            <p class="barcode-info-r">{mtrqlt}</p>
        </div>
        <div class="barcode-info">
            <p class="barcode-info-l">사이즈</p>
            <p class="barcode-info-r">
                <input
                    bind:this={steel_thickInput}
                    bind:value={steel_thick}
                    type="text"
                    style="text-align-last: center;"
                />
            </p>
        </div>
        <div class="barcode-info barcode-top">
            <p class="barcode-info-l">상위바코드</p>
            <p class="barcode-info-r barcode-scan">
                <input
                    placeholder="상위 바코드를 스캔해주세요."
                    bind:this={barcodeInput_1}
                    bind:value={barcodeInputValue_1}
                    on:input={inputBarcode}
                    id="barcode_1"
                    type="text"
                    inputmode="none"
                    style="touch-action: manipulation"
                />
            </p>
        </div>
        <div class="barcode-info">
            <p class="barcode-info-l">하위바코드</p>
            <p class="barcode-info-r barcode-scan">
                <input
                    placeholder="하위 바코드를 스캔해주세요."
                    bind:this={barcodeInput_2}
                    bind:value={barcodeInputValue_2}
                    on:input={inputBarcode}
                    id="barcode_2"
                    type="text"
                    inputmode="none"
                    style="touch-action: manipulation"
                />
            </p>
        </div>
        <div class="barcode-btn">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <p class="scan-btn-in scan-btn-r" on:click={warehousing}>저장</p>
        </div>
    </div>
</div>

<style>
</style>
